import { usePrevious } from "./UsePrevious";

export const useChanged = (value: any) => {
  const prevVal = usePrevious(value);
  return prevVal !== value;
}